import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { BellRing, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

function urlB64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export async function subscribePush() {
  const reg = await navigator.serviceWorker.ready;
  const { data } = await api.get("/public/push-key");
  const sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlB64ToUint8Array(data.publicKey) });
  await api.post("/portal/push/subscribe", { subscription: sub.toJSON() });
  return sub;
}

export default function PushPrompt() {
  const [show, setShow] = useState(false);
  const supported = typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window;

  useEffect(() => {
    if (!supported) return;
    if (Notification.permission === "granted") {
      subscribePush().catch(() => {});
    } else if (Notification.permission === "default") {
      setShow(true);
    }
  }, [supported]);

  const enable = async () => {
    try {
      const perm = await Notification.requestPermission();
      if (perm !== "granted") return setShow(false);
      await subscribePush();
      toast.success("Notifikasi aktif di perangkat ini");
      setShow(false);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[70] grid place-items-center p-6 bg-slate-900/50 backdrop-blur-sm"
          onClick={() => setShow(false)} data-testid="push-prompt-overlay">
          <motion.div initial={{ opacity: 0, scale: 0.92, y: 16 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: 0.92, y: 16 }}
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-sm bg-slate-900 text-white rounded-3xl p-6 shadow-2xl text-center"
            data-testid="push-prompt">
            <button onClick={() => setShow(false)} data-testid="push-dismiss-button" className="absolute top-4 right-4 text-white/40 hover:text-white/70"><X className="w-5 h-5" /></button>
            <span className="mx-auto w-14 h-14 rounded-2xl bg-blue-600 grid place-items-center"><BellRing className="w-7 h-7" /></span>
            <p className="mt-4 text-lg font-black">Aktifkan Notifikasi</p>
            <p className="mt-1 text-sm text-white/60">Dapatkan pengingat event, renungan, & info penting langsung ke perangkatmu.</p>
            <button onClick={enable} data-testid="push-enable-button" className="mt-5 w-full text-sm font-bold bg-white text-slate-900 rounded-xl py-3 active:scale-95 transition">Aktifkan Notifikasi</button>
            <button onClick={() => setShow(false)} data-testid="push-later-button" className="mt-2 w-full text-xs font-semibold text-white/50 py-2">Nanti saja</button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
